module.exports = __webpack_public_path__ + "static/media/squareNew.de43b4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/squareNew.png
// module id = 685
// module chunks = 0 1